import { Input } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';
import { FieldItem } from 'src/app/models/common/field-item';

export class AgentExistingInsuranceAgencyDetailsHandlerComponent extends BaseComponent<AgentService> {
  constructor(agentService: AgentService) {
    super(agentService);
  }

  public onAddAgentExistingInsuranceAgencyDetails(event) {
    this.service.addAgentExistingInsuranceAgencyDetails();
  }

  public licenseApplied_change(item: FieldItem) {
    if (item.fieldValue != null && item.fieldValue == 'F') {
      this.service.responseIO.data.LicenseList.forEach((element) => {
        element.licenseType = null;
        element.licenseNum = null;
        element.agentLicenseStatus = null;
        element.effectiveFromDt = null;
        element.effectiveToDt = null;
        element.issuingAuthority = null;
      });
    }
  }
}
